import React from 'react';
import classnames from 'classnames';
import styles from './styles.mod.scss';

export default function ProductGrid({ className, children }) {
  return <div className={classnames(styles.grid, className)}>{children}</div>;
}
